<template>
  <div class="alert" :class="[`alert-${styleType}`]">
    <i
      v-if="icon"
      :class="[!!text ? 'mr-2' : '', 'fa', `fa-${icon}`]"
    ></i>

    <span v-if="text && translateText">{{ $t(text) }}</span>
    <span v-else-if="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    icon: {
      type: String,
    },
    styleType: {
      type: String,
      default() {
        return 'info';
      },
    },
    text: {
      type: String,
    },
    translateText: {
      default() {
        return true;
      },
    },
  },
};
</script>
